// extracted by mini-css-extract-plugin
export default {"description":"details-title_description__wMG7b","step":"details-title_step__IKkhP"};